module.exports = __webpack_public_path__ + "img/en_3.5a8c9859.png";